import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Return, ActionTables } from '../inspinia'

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

class ListaValidar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            listasValidada: [
                {
                    dataFim: '',
                    dataInicio: '',
                    emailUsuario: '',
                    finalizada: '',
                    id: '',
                    linhasValidadas: [
                        {
                            conteudo: '',
                            erro: '',
                            linha: ''
                        }
                    ],
                    nomeArquivo: '',
                    status: ''
                }
            ],
            loading: false,
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleValidacaoListaImportar = this.handleValidacaoListaImportar.bind(this);
        this.importarLista = this.importarLista.bind(this);

    }

    componentDidMount() {
        this.LoadListaValidar();
    }

    handleValidacaoListaImportar() {
        this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/upload/validar");
    }

    LoadListaValidar() {
        let self = this;

        const url = `${c.API_BASE_URL}/list-validate/show`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, listasValidada: response });
        });
    }

    importarLista(id, tipoLista) {
        let telaMapear = c.CAMPAIGN_ROUTE + "/lista/validar/importar/mapear";
        let self = this;
        let url = `${c.API_BASE_URL}/list-validate/import/${tipoLista}/${id}`;
        let options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        }

        callApi(url, options, (response) => {
            if (response.status !== 'BAD_REQUEST') {
                self.props.history.push(telaMapear, { response: response });
            }
        });
    }

    render() {
        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Validar Listas</h3>
                            </Title>

                            <Content>
                                {/* TABELA */}
                                <Row className="m-0 mb-3">
                                    <Column className="p-0 mb-3 container">

                                        <Button onClick={this.handleValidacaoListaImportar}><Icon name="fa-plus" />Importar lista</Button>

                                    </Column>

                                    <Column className="p-0 table-responsive">
                                        <Table loading={this.state.loading} import={this.importarLista} data={this.state.listasValidada} history={this} />
                                    </Column>

                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column>

                                <Return to={c.CAMPAIGN_ROUTE} className="mx-1" width="100px" />

                            </Column>

                        </Row>
                    </Column>
                </Row>

            </div>
        );
    }

}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: this.props.loading,
            selfMain: this.props.history,
            historyMain: this.props.history.props.history,
            alerta: withReactContent(Swal),
            visualizar: "visualizar",
            importar: "atualizar",
            excluir: "excluir"
        }

        this.visualizarClick = this.visualizarClick.bind(this);
        this.excluir = this.excluir.bind(this);
        this.onClickExcluir = this.onClickExcluir.bind(this);
        this.disableActions = this.disableActions.bind(this);
        this.listaEmProcessamento = this.listaEmProcessamento.bind(this);
        this.listaComErro = this.listaComErro.bind(this);
        this.listaSucesso = this.listaSucesso.bind(this);
    }

    onClickExcluir(idLista) {
        this.state.alerta.fire({
            title: 'Realmente deseja excluir este item?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
                return this.excluir(idLista);
            },
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Item não excluído',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
            }
        });
    }

    excluir(id) {
        let self = this;

        const url = `${c.API_BASE_URL}/list-validate/delete/${id}`;
        const options =
        {
            method: 'DELETE'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.props.history.LoadListaValidar();
            self.setState({ ...self.state, loading: false });
            c.TOASTER_SUCCESS("Lista excluída com sucesso!");
        });
    }

    visualizarClick(id) {
        if (id == undefined) return;
        if (parseInt(id) === 0) return;

        this.state.historyMain.push(c.CAMPAIGN_ROUTE + "/lista/validar/detalhes/" + id);
    }

    disableActions(status, tipo) {
        if (status == "Em Processamento") {
            return this.listaEmProcessamento(tipo);
        } else if (status == "Com Erro") {
            return this.listaComErro(tipo);
        } else if (status == "Sucesso") {
            return this.listaSucesso(tipo);
        }
    }

    listaEmProcessamento(tipo) {
        if (tipo == this.state.visualizar) {
            return true;
        }

        if (tipo == this.state.importar) {
            return true;
        }

        if (tipo == this.state.excluir) {
            return true;
        }
    }

    listaComErro(tipo) {
        if (tipo == this.state.visualizar) {
            return false;
        }

        if (tipo == this.state.importar) {
            return true;
        }

        if (tipo == this.state.excluir) {
            return false;
        }
    }

    listaSucesso(tipo) {
        if (tipo == this.state.visualizar) {
            return true;
        }

        if (tipo == this.state.importar) {
            return false;
        }

        if (tipo == this.state.excluir) {
            return false;
        }
    }


    statusEnvio(status) {
        if (status == "Em Processamento") {
            return (<span style={{ color: "#EF7800" }}>Em Processamento</span>)
        }
        else if (status == "Com Erro") {
            return (<span style={{ color: "#ff0000" }}>Com Erro</span>)
        }
        else if (status == "Sucesso") {
            return (<span style={{ color: "#47A789" }}>Sucesso</span>)
        }
    }

    formatarData(data) {
        return data.split("T")[0];
    }

    importar(row) {
        this.setState({ ...this.state, loading: true });
        return this.props.import(row.id, row.tipoListaContato);
    }

    render() {
        const data = this.props.data;
        let html = "";

        if (data === undefined || this.props.loading || this.state.loading) {
            html = (<div className="sk-spinner sk-spinner-three-bounce">
                <div className="sk-bounce1"></div>
                <div className="sk-bounce2"></div>
                <div className="sk-bounce3"></div>
            </div>);
        }
        else if (data.length === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.length > 0) {
            html = (<table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th>Nome da lista</th>
                        <th>Data</th>
                        <th>Status</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map(row =>
                            <tr key={row.id} id={row.id}>
                                <td>{row.nomeArquivo}</td>
                                <td>{this.formatarData(row.dataInicio)}</td>
                                <td>{this.statusEnvio(row.status)}</td>
                                <td className="text-center">
                                    <ActionTables name="visualizar" onClick={() => this.visualizarClick(row.id)} disabled={this.disableActions(row.status, "visualizar")} > <Icon name="fa-search" className="mx-1 text-info" /> </ActionTables>
                                    <ActionTables name="importar" onClick={() => this.importar(row)} disabled={this.disableActions(row.status, "atualizar")} > <Icon name="fa-arrow-right" className="mx-1 text-info" /> </ActionTables>
                                    <ActionTables name="excluir" onClick={() => this.onClickExcluir(row.id)} disabled={this.disableActions(row.status, "excluir")} > <Icon name="fa-trash" className="mx-1" color="red" /> </ActionTables>
                                </td>
                            </tr>)
                    }

                </tbody>
            </table>);
        }

        return (
            <div>{html}</div>
        )
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaValidar));
